import React, { Component } from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";

class UserMenu extends Component {
  render() {
    const gear = require("../../images/gears.png").default;
    const { email, authentication, org } = this.props;

    const org_id =
      org.current_org_id === null
        ? authentication.user.org_id
        : org.current_org_id;

    return (
      <div className="dropdown">
        <a className="loginlink">
          <span className="arrow-down"></span>&nbsp;&nbsp;{email}
        </a>
        <div className="dropdown-content">

          <Link to="/tos" action="tos">
            terms of service
          </Link>

          <Link to="/login" action="logout">
            logout
          </Link>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  const { authentication, org } = state;
  return {
    authentication,
    org,
  };
}

const connectedUserMenu = connect(mapStateToProps)(UserMenu);
export { connectedUserMenu as UserMenu };
